import StoreBuilder from '../store-builder';
import { TiersApi } from '@/api/tiers';
import { CommandeSAS } from '@/model/commande/sas/commande-sas';
import { LigneCommandeSAS } from '@/model/commande/sas/ligne-commande-sas';
import { CommandeApi } from '@/api/commande';

const builder = new StoreBuilder('tiers');

builder.setLoaders({
  commandes: {
    loadFunction: (numTiers: string) => CommandeApi.getHistoriqueCommandes(numTiers).then((commandes: CommandeSAS[]) => {
      commandes.forEach((commande: CommandeSAS) => {
        commande.lignes.forEach((ligne: LigneCommandeSAS) => {
          ligne.numeroCommande = commande.numero;
          ligne.dateCommande = commande.date;
        });
      });
      return commandes;
    }),
    cacheTime: 60
  }
});

builder.addStatePart('infosTiers', null, (numTiers:string) => TiersApi.getInfosTiers(numTiers), 'SESSION', 1800);
builder.addStatePart('commandes', null, (numTiers: string) => CommandeApi.getHistoriqueCommandes(numTiers), 'SESSION', 3600);

export default builder.build();
